import { projectSchema } from '@/models/projectSchema';
import { store } from '@/redux/store';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { GetDiseaseReturnType } from '@/services/pluginsManager/pluginsManager.types';
import { toOptionalPluginAnnotation } from '@/services/pluginsManager/adapters/toPluginAnnotation';
import { ERROR_PROJECT_NOT_FOUND } from '../../errorMessages';

export const getDisease = (): GetDiseaseReturnType => {
  const project = store.getState().project.data;

  if (!project) throw new Error(ERROR_PROJECT_NOT_FOUND);

  const isDataValid = validateDataUsingZodSchema(project, projectSchema);

  return isDataValid ? toOptionalPluginAnnotation(project.disease) : undefined;
};
